import { Component, Signal, signal, ChangeDetectionStrategy, inject } from '@angular/core';

import { ModalLayoutComponent } from '../modal-layout/modal-layout.component';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { UI_FORM_IMPORTS } from '../../../ui-form-imports';
import { ButtonComponent } from '@program-suite/ui';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LookupViewModel } from '@program-suite/data-common';

export interface FileUploadData {
  title: string;
  subTitle: string;
  acceptedFormats: string[];
  fileTypes: Signal<LookupViewModel[]>;
};


@Component({
  selector: 'lib-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ModalLayoutComponent,
    ReactiveFormsModule,
    FormsModule,
    ButtonComponent,
    ...UI_FORM_IMPORTS
],
})
export class FileUploadComponent {
  data:FileUploadData = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<FileUploadComponent>)
  acceptedFormats = signal(['PDF', 'XLSX', 'DOCX', 'JPG', 'PNG']);
  fileTypeForm: FormGroup;

  constructor() {
    this.fileTypeForm = new FormGroup({
      fileType: new FormControl('', Validators.required),
      files: new FormControl([], Validators.required),
    });
  }

  uploadFiles() {
    this.fileTypeForm.markAsTouched();
    if (this.fileTypeForm.valid) {
      const form = {
        documentType: this.fileTypeForm.get('fileType')?.value,
        files: this.fileTypeForm.get('files')?.value
      }
      this.dialogRef.close(form);
    }
  }
}
